import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgKbSharedRoutingModule } from './sg-kb-shared-routing.module';
import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';


@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    SgKbSharedRoutingModule,
    SgBaseSharedModule
  ],
  exports: [
  ],
  providers: [
  ]
})
export class SgKbSharedModule { }
